import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BriefSet from "./BriefSet";
import type User from "./User";

@Model()
class BriefSetsUser extends ApplicationRecord {
  static jsonapiType = "brief_sets_users";

  @Attr({ persist: false }) archivedAt: string;

  @BelongsTo() briefSet: BriefSet;

  @Attr() briefSetId: number;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default BriefSetsUser;
